<template>
  <main>
    <TeaserAktion
      :step="step"
      @show-form="step = 'form'"
    />
    <template v-if="step === 'inactive'">
      <GridContainer padding>
        <DcbCardNewsletter />
      </GridContainer>
    </template>
    <template v-if="step === 'mailSent'">
      <GridContainer padding>
        <ShortInstructions />

        <PartnerV3 />

        <DcbStepBreadcrumb
          :heading="dcbStepsHeading"
          :is-mail-sent="step === 'mailSent'"
        />
      </GridContainer>
    </template>
    <template v-else-if="step === 'form'">
      <GridContainer
        padding
        class="handyrechnung__grid-small"
      >
        <MailForm
          :show-form="step === 'form'"
          @mail-sent="step = 'mailSent'"
          @show-error="step = 'alreadyRegistered'"
        />

        <DcbStepBreadcrumb :heading="dcbStepsHeading" />
      </GridContainer>
    </template>

    <GridContainer padding>
      <FaqForm with-lottery />
    </GridContainer>
  </main>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useFeatures } from '~/composables/use-features';

import { getHeader } from '~/helpers/page-header-compositon';
import { Track } from '~/helpers/page-tracking';
import { useServerDateStore } from '~/stores/server-date';

import { GridContainer } from '@i22team/td-longtail-vue-components';

import MailForm from '~/components/dcb/mail-form.vue';
import TeaserAktion from '~/components/dcb/teaser-aktion.vue';
import FaqForm from '~/components/dcb/faq-form.vue';
import DcbStepBreadcrumb from '~/components/dcb/dcb-step-breadcrumb.vue';
import DcbCardNewsletter from '~/components/dcb/dcb-card-newsletter.vue';
import ShortInstructions from '~/components/dcb/short-instructions.vue';
import PartnerV3 from '~/components/dcb/partner-v3.vue';
import { type DcbStep, useDoubleOptIn } from '~/lib/dcb/dcb-double-opt-in';

definePageMeta({
  isIndexed: false,
});

Track();
getHeader({
  title: ref('Zahlen per Handyrechnung Aktion'),
  description: ref(
    'Mit der Handyrechnung zahlen und bis zu 5 € Gutschrift sichern. Jetzt bis zum 30.06.2026 registrieren!'
  ),
});

const { serverDateTimestamp } = storeToRefs(useServerDateStore());

const step = ref<DcbStep>(
  serverDateTimestamp.value >= new Date('2026-06-30 23:59:00').getTime() ? 'inactive' : 'form'
);

const dcbStepsHeading =
  "5 € Gutschrift für App-Käufe und In-App-Käufe nutzen? So geht's ganz einfach";

const { features } = useFeatures();

useDoubleOptIn(step);

onMounted(() => {
  if (features.dcbMailSent.enabled) {
    step.value = 'mailSent';
  }

  if (features.dcbSpecialEnded.enabled) {
    step.value = 'inactive';
  }
});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.handyrechnung {
  &__grid-small {
    max-width: 900px;
  }
}
</style>
